export { default as WishlistButton } from './components/WishlistButtonContainer.js';
//# sourceMappingURL=button.js.map
